import React from "react";
import {
  UserOutlined,
  GlobalOutlined,
  ClockCircleOutlined,
  SettingOutlined,
  CalendarOutlined,
  FileImageOutlined,
  BgColorsOutlined,
  CarOutlined
} from "@ant-design/icons";
import { Menu } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import getCatalogName from "@/helpers/getCatalogName";

function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}

const ManagementSidebar = () => {
  const catalogName = getCatalogName();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t } = useTranslation();

  // Aktif menü key'ini route'dan çıkar
  const selectedKey = pathname.split("/")[2] || "";

  const handleClick = (e) => {
    navigate('/management/' + e.key);
  };

  const items = [
    getItem(t('Users'), "users", <UserOutlined />),
    getItem(t('Languages'), "languages", <GlobalOutlined />),
    getItem(t('Working Hours'), "working-hours", <ClockCircleOutlined />),
    getItem(t('Settings'), "settings", <SettingOutlined />),
    getItem(t('Announcemenets'), "announcemenets", <CalendarOutlined />),
    getItem(t('Carousel'), "carousel", <FileImageOutlined />),
    getItem(t('Theme'), "theme", <BgColorsOutlined />),
    catalogName === 'TECDOC' && getItem(t('Catalog'), "catalog-tecdoc", <CarOutlined />),
  ].filter(Boolean); // Eğer false dönerse (örneğin TECDOC değilse), item'ı çıkar

  return (
    <div className="management-sidebar">
      <Menu
        onClick={handleClick}
        mode="inline"
        style={{ width: "100%" }}
        items={items}
        selectedKeys={[selectedKey]} // Aktif menüyü göster
      
      />
    </div>
  );
};

export default ManagementSidebar;
